import { render } from "./WebTechnology.vue?vue&type=template&id=267d9089&scoped=true"
import script from "./WebTechnology.vue?vue&type=script&lang=js"
export * from "./WebTechnology.vue?vue&type=script&lang=js"

import "./WebTechnology.vue?vue&type=style&index=0&id=267d9089&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267d9089"]])

export default __exports__